import { Renderer2, Component, OnInit, ViewChild, Input, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { GatemanService } from '../../services/gateman.service';
import { PageService } from '../../services/page.service';
import { PopoverController } from '@ionic/angular';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']

})
export class HeaderComponent implements OnInit, AfterViewInit, OnChanges {
  bgStyle: string;
  @ViewChild('toolbar', { read: ElementRef }) toolbar;

  /**
   * @description Added showLanguageSelector to the config and set dafult in ngOnInit to false
   * @updated by Abhishek
   * @updatedOn 11 july, 2019
   * @task QLIKTAG-3253
   */
  @Input() config: {
    sticky?: boolean,
    isBackButtonVisible?: boolean,
    isMenuButtonVisible?: boolean,
    bgImageUrl?: string,
    isContentHeader?: boolean,
    bgColor?: string,
    headerText?: string;
    class?: string;
    showLanguageSelector?: boolean; // Default set to false ngOnInit
  };

  @Input() languages?: any[];

  /**
   * @author - SwapnilP
   * @task - QLIKTAG-2888
   */
  constructor(
    private renderer: Renderer2,
    private pageService: PageService,
    private gatemanService: GatemanService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private popoverController: PopoverController,
    private router: Router,) { }

  /**
   * [ngOnChanges Called whenever input of component changes ]
   * @param  changes [Changes object holds  delta of input properties]
   * @return         [description]
   * @author - SwapnilP
   * @task - QLIKTAG-2888
   */
  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes);
    // Each time data is updated after first rendering, build bgStyle and apply it.
    if (changes.config && !changes.config.firstChange) {
      this.render();
    }
  }
  /**
   * @author - SwapnilP
   * @task - QLIKTAG-2888
   */
  ngOnInit() {
    //console.log(this.config);

    if (this.config && !this.config.hasOwnProperty('showLanguageSelector')) {
      this.config.showLanguageSelector = false;
    }
  }

  /**
   * For the first time, style has to be applied after dom completes rendering
   * @author - SwapnilP
   * @task - QLIKTAG- 2888
   */
  ngAfterViewInit() {
    this.render();
  }

  /**
   * [render build and apply bgStylle build as --background variable]
   * @return [description]
   * @author - SwapnilP
   * @task = QLIKTAG - 2888
   */
  render() {
    // Build Style Object
    this.bgStyle = '#FFFFFF';
    if (this.config) {
      if (this.config.bgColor) {
        this.bgStyle = `${this.config.bgColor}`;
      }
      // NOTE: Imge URL processing commneted temporarily
      // if (this.config.bgImageUrl) {
      //   if (this.config.bgColor) {
      //     this.bgStyle = `url(${this.config.bgImageUrl}) no-repeat center center / cover ${this.config.bgColor}`;
      //   } else {
      //     this.bgStyle = `url(${this.config.bgImageUrl}) no-repeat center center / cover`;
      //   }
      // } else {
      //   if (this.config.bgColor) {
      //     this.bgStyle = `${this.config.bgColor}`;
      //   }
      // }
    }
    // Apply It
    /**
     * NOTE: Internally Ionic Variable styles are applied through cssText Property.
     * Renderer doesnt implicitely modify it.
    */
    if (this.toolbar) {
      this.renderer.setStyle(this.toolbar.nativeElement, 'cssText', `--background: ${this.bgStyle}`);
    }
    // setStyle function on style object internally modifies cssText property.
    // if (this.toolbar) {
    //   const style = this.toolbar.nativeElement.style;
    //   if (this.bgStyle) {
    //     style.setProperty('--background', this.bgStyle);
    //   }
    // }
  }

  /**
   * [ goBack Backbutton on inner smartlabel header ]
   * @return [nothing]
   * @author - SwapnilP
   * @task - QLIKTAG- 2888
   */
  goBack() {
    const { sandbox, detail } = this.activatedRoute.snapshot.queryParams;
    if (sandbox) {
      let alias = '';
      let preserveFragment = false;
      if (detail) {
        alias = this.pageService.pageAlias;
        preserveFragment = true;
      } else {
        const firstPage = this.pageService.pageLookup('', this.pageService.diLayout.pages, 1);
        alias = firstPage.alias;
      }
      // 1.
      this.gatemanService.routeMe(`p/${alias}`, { queryParams: { resetQueryParams: 1 }, preserveFragment: preserveFragment });
    } else {
      this.location.back();
    }
  }

  /**
   * [Method to present popover of language list]
   * @task QLIKTAG-3253
   * @author Abhishek
   */
  async presentPopover(ev: any) {

    const popover = await this.popoverController.create({
      component: LanguageSelectorComponent,
      componentProps: {
        languages: this.languages,
        currentLang: this.pageService.appLang$.getValue(),
        templateLanguages: this.pageService.diLanguages
      },
      event: ev,
      translucent: true
    });
    return await popover.present();
  }
}
